import { Link } from 'react-router-dom'
import styles from './Header.module.css'

export default function Header() {
  return (
    <div className={styles.header}>
      <div className={styles.title}>
        <Link to="/agencies">Agency Directory</Link>
      </div>

      <a
        href="/agencies/agency_signup.html"
        className="sb-agency-signup-button  sb-agency-signup-button--default"
      >
        List Your Agency
      </a>
    </div>
  )
}
